import { getData, putData } from "../apiClient";

const API_BASE = "common-setting";

/**
 * Retrieves the global site configuration by ID.
 */
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_BASE}/get/${id}`);
    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    console.error("Get Common Setting API error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Retrieves columns from the language table to use as localization options.
 */
export const getAllLanguage = async () => {
  try {
    const result = await getData(`/${API_BASE}/all/language`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Language list API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

/**
 * Updates the global site settings.
 * Supports multipart/form-data for logo uploads.
 */
export const Update = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_BASE}/update/${id}`, data, { 
      'Content-Type': 'multipart/form-data' 
    });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update Common Setting API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};
